import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { initMobile } from "../lib/mobile";

/**
 * Mounted once at app boot — wires up Capacitor (push notifications,
 * universal links, Android back button). No-ops cleanly on web.
 */
export default function MobileBootstrap() {
  const nav = useNavigate();
  useEffect(() => {
    initMobile(nav);
  }, [nav]);
  return null;
}
